import { addMinutes } from 'date-fns'

export const getItemsHorarioFinal = (map: Map<Date, { duracao: number }>, inicial: Date, final: Date) =>
  Array.from(map.keys())
    .filter((horario) => Number(horario) >= Number(inicial) && (!final || Number(horario) < Number(final)))
    .map((horario) => addMinutes(horario, map.get(horario).duracao))
